import { useEffect } from 'react'
import { Alert, Group, Loader } from '@mantine/core'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { api } from '@/api/client'
import { BASE_MEU_ROBO } from '@/api/robo'
import { RoboDmPortao } from './RoboDmPortao'

/**
 * `/chat/robo`, o link sem id que o guia e links antigos ainda usam: abre (ou
 * reabre) a conversa com o robô e vai para ela na tela de Conversas.
 */
export default function AbrirConversaDoRobo() {
  return <RoboDmPortao>{() => <Abrir />}</RoboDmPortao>
}

function Abrir() {
  const navigate = useNavigate()
  const abrir = useMutation({
    mutationFn: async () => (await api.post<{ conversation_id: number }>(`${BASE_MEU_ROBO}/conversation`)).data,
    onSuccess: (d) => navigate(`/chat/${d.conversation_id}`, { replace: true }),
  })
  useEffect(() => { abrir.mutate() }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return abrir.isError
    ? <Alert m="md" color="red">Não foi possível abrir a conversa. Tente novamente.</Alert>
    : <Group p="md"><Loader size="sm" type="dots" /></Group>
}
